import { Script } from "gatsby"

import { useCookieConsent } from "@hooks/use-cookie-consent"

const Pendo = () => {
  const { hasFunctionalCookieConsent } = useCookieConsent()

  const pendoFunction = (
    <Script type="text/javascript">{`
      (function(apiKey){
          (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
          v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
              o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
              y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
              z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
      })('08eb7aa5-3521-4ef5-597f-4d6073b28ef8');

      const initializePendo = () => {
        if (window.pendo) {
          return window.pendo.initialize({
            // Leave visitor and account empty for anonymous tracking
            visitor: {
              id: null,
            },
            account: {
              id: null,
            },
          })
        } else {
          console.log("Pendo is not ready yet, retrying...")
          setTimeout(initializePendo, 500)
        }
      }

      initializePendo()
    `}</Script>
  )

  // If the 'OptanonConsent' cookie exist and the 'func' permission is true (the user permitted the functionality cookie) => we load pendo
  if (hasFunctionalCookieConsent) {
    return pendoFunction
  }
  return null
}
export default Pendo
